/* Configuratorul comenzii.

   Ce face:  alegi serviciul și pachetul → încarci fotografiile (urcă direct la serviciul
             nostru, nu în coș) → numărul de WhatsApp → rezumat → coșul Shopify → checkout.
   Ce NU face: nu ține prețuri. Toate sumele vin din produsele Shopify, prin blocul JSON
             din sections/rf-order.liquid. În coș intră doar produse reale + codul proiectului. */
(function () {
  'use strict';

  var STORE_KEY = 'rf_order_v1';
  var ICON = {
    upload: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 15.5V4.5M7.500 9L12 4.500 16.500 9"/><path d="M4.500 15.500V18A1.500 1.500 0 0 0 6 19.500h12a1.500 1.500 0 0 0 1.500-1.500v-2.500"/></svg>',
    check: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.500l4.500 4.500L19 7.500"/></svg>',
    close: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.200" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    plus: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    shield: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.600" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.500l7 2.500v5.500c0 4.300-2.900 7.600-7 9-4.100-1.400-7-4.700-7-9V6l7-2.500z"/><path d="M8.800 12.200l2.300 2.300 4.200-4.400"/></svg>',
    warn: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.700" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 4.200l8.300 14.300H3.700L12 4.200z"/><path d="M12 10v4.200M12 16.600v.100"/></svg>',
    lock: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.600" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="10.500" width="14" height="9.500" rx="2"/><path d="M8 10.500V8a4 4 0 0 1 8 0v2.500"/></svg>'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Numere de mobil din România (07xx xxx xxx) sau, cu prefix, din orice țară. */
  function normalizePhone(value) {
    var d = String(value || '').replace(/[\s\-().\/]/g, '');
    if (/^00\d/.test(d)) d = '+' + d.slice(2);
    if (/^07\d{8}$/.test(d)) return '+4' + d;
    if (/^7\d{8}$/.test(d)) return '+40' + d;
    if (/^407\d{8}$/.test(d)) return '+' + d;
    if (/^\+407\d{8}$/.test(d)) return d;
    if (/^\+40/.test(d)) return null;                       // România, dar nu e număr de mobil valid
    if (/^\+[1-9]\d{7,14}$/.test(d)) return d;
    return null;
  }
  function prettyPhone(e164) {
    var m = /^\+40(\d{3})(\d{3})(\d{3})$/.exec(e164);
    return m ? '+40 ' + m[1] + ' ' + m[2] + ' ' + m[3] : e164;
  }

  function validEmail(value) {
    var v = String(value || '').trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) && v.length <= 120 ? v.toLowerCase() : null;
  }

  function emptyState() {
    return { service: 'restore', pack: null, projectId: null, token: null,
             files: {}, notes: {}, color: {}, persons: 1, delivery: 'whatsapp', phone: '', email: '', consent: false, urgent: false, demo: null, hasCode: false, code: '' };
  }

  function init(sec) {
    if (sec.hasAttribute('data-rf-bound')) return;
    sec.setAttribute('data-rf-bound', '');

    var cfg;
    try { cfg = JSON.parse(sec.querySelector('[data-rf-order-json]').textContent); } catch (e) { return; }
    var t = cfg.t || {};
    var box = sec.querySelector('[data-rf-config]');
    var tabs = sec.querySelectorAll('[data-rf-service-tab]');
    var panes = sec.querySelectorAll('[data-rf-pane]');
    var packBtns = sec.querySelectorAll('[data-rf-pack]');

    var state = Object.assign(emptyState(), RF.store.get(STORE_KEY, {}));
    // o urcare întreruptă de închiderea paginii nu mai are cum să se termine
    Object.keys(state.files).forEach(function (k) { if (state.files[k].status !== 'done') delete state.files[k]; });
    if (state.service === 'person' && !cfg.person) state.service = 'restore';
    // Pachetul se ține minte după numărul de fotografii, nu după poziția lui: când ordinea pachetelor se schimbă
    // în temă, o alegere mai veche ar arăta altfel spre alt pachet (cel de 1 fotografie devenea cel de 10).
    if (state.pack != null) {
      var kept = cfg.packages.filter(function (p) { return p.photos === state.packPhotos; })[0];
      state.pack = kept ? kept.index : null;
    }
    if (!cfg.urgent) state.urgent = false;
    // nimic ales încă: pornim cu pachetul bifat din start în temă
    if (state.pack == null && cfg.preselect != null) { state.pack = cfg.preselect; if (!pack()) state.pack = null; }

    var errors = [], busy = false, saveTimer = 0;
    // codul de reducere: { code, status: 'checking' | 'ok' | 'bad' | 'later', amount (bani scazuti), key (pentru ce comanda a fost verificat) }
    var discount = null, discountRun = 0;

    function save() {
      clearTimeout(saveTimer);
      state.packPhotos = pack() ? pack().photos : null;
      saveTimer = setTimeout(function () { RF.store.set(STORE_KEY, state); }, 250);
    }
    function pack() { return cfg.packages.filter(function (p) { return p.index === state.pack; })[0] || null; }
    function money(c) { return RF.formatMoney(c, cfg.moneyFormat); }
    // texte cu un număr în ele: „Fotografia [n]”
    function tx(key, n) { return String(t[key] || '').replace('[n]', n); }

    /* -------------------------------------------- ce fotografii sunt necesare */
    function slots() {
      var list = [];
      if (state.service === 'restore') {
        var p = pack();
        for (var i = 1; p && i <= p.photos; i++) list.push({ key: 'photo-' + i, title: tx('slotPhoto', i), kind: 'photo', n: i });
      } else {
        list.push({ key: 'main', title: t.slotMain, kind: 'main' });
        for (var n = 1; n <= state.persons; n++) list.push({ key: 'p' + n, title: tx('slotPerson', n), kind: 'person', n: n });
      }
      return list;
    }
    function refKeys(n) {
      var keys = [];
      for (var i = 1; i <= cfg.maxRefs; i++) keys.push('p' + n + '-ref-' + i);
      return keys;
    }
    function done(key) { return state.files[key] && state.files[key].status === 'done'; }
    function personReady(n) { return refKeys(n).some(done); }
    function progress() {
      var need = slots(), ok = 0;
      need.forEach(function (s) { if (s.kind === 'person' ? personReady(s.n) : done(s.key)) ok += 1; });
      return { ok: ok, total: need.length };
    }
    function extraPersons() {
      return cfg.person ? Math.max(0, state.persons - cfg.person.included) : 0;
    }
    function urgentOn() { return !!(cfg.urgent && state.urgent); }
    function total() {
      var base = state.service === 'restore' ? (pack() ? pack().price : 0)
        : (cfg.person ? cfg.person.price + extraPersons() * (cfg.extra ? cfg.extra.price : 0) : 0);
      return base + (urgentOn() && base ? cfg.urgent.price : 0);
    }
    function discountOff() { return discount && discount.status === 'ok' && discount.key === orderKey() ? discount.amount : 0; }
    function toPay() { return Math.max(0, total() - discountOff()); }

    /* ------------------------------------------------------ cod de reducere */
    // ce se cumpara, fara datele proiectului: daca se schimba, reducerea trebuie socotita din nou
    function cartLines() {
      var lines = [];
      if (state.service === 'restore') { if (pack()) lines.push({ id: pack().variantId, quantity: 1 }); }
      else if (cfg.person) {
        lines.push({ id: cfg.person.variantId, quantity: 1 });
        if (extraPersons() > 0 && cfg.extra) lines.push({ id: cfg.extra.variantId, quantity: extraPersons() });
      }
      if (urgentOn() && lines.length) lines.push({ id: cfg.urgent.variantId, quantity: 1 });
      return lines;
    }
    function orderKey() { return cartLines().map(function (l) { return l.id + 'x' + l.quantity; }).join(','); }
    function cleanCode(v) { return String(v || '').trim().toUpperCase().slice(0, 40); }

    // Codul se verifica la Shopify, nu la noi: punem comanda in cos, ii dam codul si citim ce a scazut.
    function applyCode() {
      var code = cleanCode(state.code), lines = cartLines(), key = orderKey(), run = ++discountRun;
      if (!state.hasCode || !code || !lines.length) { discount = null; refreshSummary(); return; }
      if (RF.cfg.preview) { discount = { code: code, status: 'later' }; refreshSummary(); return; }   // previzualizare locală: nu există coș
      discount = { code: code, status: 'checking' }; refreshSummary();
      post(cfg.cartClearUrl)
        .then(function () { return post(cfg.cartAddUrl, { items: lines }); })
        .then(function () { return post(cfg.cartUpdateUrl, { discount: code }); })
        .then(function (cart) {
          if (run !== discountRun) return;                    // intre timp s-a cerut alta verificare
          var found = (cart.discount_codes || []).filter(function (d) { return cleanCode(d.code) === code; })[0];
          var off = Math.max(0, (cart.original_total_price || 0) - (cart.total_price || 0));
          discount = !cart.discount_codes ? { code: code, status: 'later' }
            : found && found.applicable && off > 0 ? { code: code, status: 'ok', amount: off, key: key }
            : { code: code, status: 'bad' };
          RF.track('discount_code', { status: discount.status });
          refreshSummary();
        })
        .catch(function () { if (run === discountRun) { discount = { code: code, status: 'later' }; refreshSummary(); } });
    }
    // dupa ce se schimba pachetul, persoanele sau livrarea urgenta
    function recheckCode() { if (state.hasCode && cleanCode(state.code) && discount) applyCode(); }

    function codeHtml() {
      if (!t.codeToggle) return '';
      var msg = !discount ? '' : discount.status === 'checking' ? '<span class="rf-field__msg">' + esc(t.codeChecking) + '</span>'
        : discount.status === 'ok' ? '<span class="rf-field__msg rf-field__msg--ok">' + esc(t.codeOk) + '</span>'
        : discount.status === 'bad' ? '<span class="rf-field__msg rf-field__msg--error">' + esc(t.codeBad) + '</span>'
        : '<span class="rf-field__msg">' + esc(t.codeLater) + '</span>';
      return '<div class="rf-code">' +
        '<label class="rf-check"><input type="checkbox" data-has-code' + (state.hasCode ? ' checked' : '') + '><span>' + esc(t.codeToggle) + '</span></label>' +
        (state.hasCode ? '<div class="rf-code__row"><input class="rf-input" type="text" autocapitalize="characters" autocomplete="off" spellcheck="false" maxlength="40" placeholder="' + esc(t.codePlaceholder) + '" aria-label="' + esc(t.codeToggle) + '" data-code value="' + esc(state.code) + '">' +
          '<button type="button" class="rf-btn rf-btn--ghost rf-code__btn" data-code-apply' + (discount && discount.status === 'checking' ? ' disabled' : '') + '>' + esc(t.codeApply) + '</button></div>' + msg : '') +
        '</div>';
    }

    /* ----------------------------------------------------------- desenare */
    function fileHtml(key, mini) {
      var f = state.files[key];
      if (!f) {
        return '<label class="rf-drop' + (mini ? ' rf-drop--mini' : '') + '" data-drop="' + key + '">' +
          '<input type="file" accept="image/*" class="rf-sr" data-file="' + key + '">' +
          '<span class="rf-drop__icon">' + ICON.upload + '</span>' +
          (mini ? '<span>' + esc(t.addShort) + '</span>' : '<span class="rf-drop__title">' + esc(t.upload) + '</span><span class="rf-small">' + esc(t.uploadHint) + '</span>') +
          '</label>';
      }
      var badge = f.status === 'done' ? '<span class="rf-file__state rf-file__state--ok">' + ICON.check + (mini ? '' : esc(t.stateDone)) + '</span>'
        : f.status === 'error' ? '<span class="rf-file__state rf-file__state--error">' + (mini ? '!' : esc(t.stateError)) + '</span>'
        : '<span class="rf-file__state">' + (mini ? '…' : esc(t.stateUploading)) + '</span>';
      var bar = f.status === 'uploading' ? '<span class="rf-file__bar"><i data-bar="' + key + '" style="width:' + (f.progress || 0) + '%"></i></span>' : '';
      if (mini) {
        return '<div class="rf-file rf-file--mini"><img src="' + esc(f.thumb) + '" alt="">' + badge + bar +
          '<button type="button" class="rf-file__x" data-remove="' + key + '" aria-label="' + esc(t.remove) + '">' + ICON.close + '</button></div>';
      }
      return '<div><div class="rf-file"><img src="' + esc(f.thumb) + '" alt="">' + badge + bar + '</div>' +
        '<div class="rf-file__actions">' +
        '<label class="rf-mini-btn"><input type="file" accept="image/*" class="rf-sr" data-file="' + key + '">' + esc(t.replace) + '</label>' +
        '<button type="button" class="rf-mini-btn" data-remove="' + key + '">' + esc(t.remove) + '</button>' +
        (f.status === 'error' ? '<span class="rf-field__msg rf-field__msg--error" style="align-self:center">' + esc(f.error || t.errRetry) + '</span>' : '') +
        '</div></div>';
    }

    // indicatia e optionala, deci sta pliata pana cand omul o deschide (un pachet de 10 ar fi altfel foarte lung)
    function noteHtml(key, label, placeholder) {
      var value = state.notes[key] || '';
      return '<details class="rf-more"' + (value ? ' open' : '') + '><summary>' + label + ' <small>' + esc(t.optional) + '</small></summary>' +
        '<textarea class="rf-textarea" maxlength="300" aria-label="' + esc(label) + '" data-note="' + key + '" placeholder="' + esc(placeholder) + '">' + esc(value) + '</textarea></details>';
    }

    function slotHtml(s) {
      if (s.kind === 'photo') {
        return '<div class="rf-card rf-slot" data-slot="' + s.key + '">' +
          '<div class="rf-slot__head"><p class="rf-slot__title">' + s.title + '</p></div>' +
          '<div data-media="' + s.key + '">' + fileHtml(s.key) + '</div>' +
          '<label class="rf-check"><input type="checkbox" data-color="' + s.key + '"' + (state.color[s.key] !== false ? ' checked' : '') + '><span>' + esc(t.wantColor) + '</span></label>' +
          noteHtml(s.key, esc(t.noteLabel), t.notePlaceholder || '') +
          '</div>';
      }
      if (s.kind === 'main') {
        return '<div class="rf-card rf-slot" data-slot="main">' +
          '<div class="rf-slot__head"><p class="rf-slot__title">' + s.title + '</p></div>' +
          '<p class="rf-slot__hint">' + esc(t.mainHint) + '</p>' +
          '<div data-media="main">' + fileHtml('main') + '</div>' +
          noteHtml('main', esc(t.noteLabel), t.mainNotePlaceholder) +
          '</div>';
      }
      var extra = cfg.person && cfg.extra && s.n > cfg.person.included;
      return '<div class="rf-card rf-slot" data-slot="' + s.key + '">' +
        '<div class="rf-slot__head"><p class="rf-slot__title">' + s.title + '</p>' +
        (extra ? '<span class="rf-slot__tag">+ ' + money(cfg.extra.price) + '</span>' : '') +
        (s.n > 1 && s.n === state.persons ? '<button type="button" class="rf-mini-btn" data-remove-person>' + esc(t.removePerson) + '</button>' : '') +
        '</div>' +
        '<p class="rf-slot__hint">' + esc(tx('refsLabel', cfg.maxRefs)) + ' ' + esc(t.refsHint || '') + '</p>' +
        (cfg.maxRefs === 1
          ? '<div data-media="' + refKeys(s.n)[0] + '">' + fileHtml(refKeys(s.n)[0]) + '</div>'
          : '<div class="rf-refs">' + refKeys(s.n).map(function (k) { return '<div data-media="' + k + '" data-mini>' + fileHtml(k, true) + '</div>'; }).join('') + '</div>') +
        noteHtml(s.key, esc(t.personNoteLabel), t.personNotePlaceholder) +
        '</div>';
    }

    function summaryHtml() {
      var pr = progress(), p = pack(), rows = [];
      var phone = normalizePhone(state.phone), email = validEmail(state.email);
      rows.push([t.sumService, state.service === 'restore' ? t.serviceRestore : t.servicePerson]);
      if (state.service === 'restore') rows.push([t.sumPack, p.photos + ' ' + (p.photos === 1 ? t.photoOne : t.photoMany)]);
      else rows.push([t.sumPersons, String(state.persons)]);
      rows.push([state.service === 'restore' ? t.sumUploaded : t.sumSteps, pr.ok + '/' + pr.total, pr.ok < pr.total]);
      rows.push([t.sumDelivery, state.delivery === 'email'
        ? t.deliveryEmailName + (email ? ' · ' + email : '')
        : t.delivery + (phone ? ' · ' + prettyPhone(phone) : '')]);
      rows.push([t.sumTime, urgentOn() ? t.urgentTime : t.time]);
      if (state.service === 'person') {
        rows.push([cfg.person.title, money(cfg.person.price)]);
        if (extraPersons() > 0 && cfg.extra) rows.push([extraPersons() + ' × ' + cfg.extra.title, money(extraPersons() * cfg.extra.price)]);
      }
      if (state.service === 'restore' && urgentOn()) rows.push([p.title, money(p.price)]);
      if (urgentOn()) rows.push([cfg.urgent.title, money(cfg.urgent.price)]);
      if (discountOff()) rows.push([t.codeRow + ' (' + discount.code + ')', '− ' + money(discountOff())]);
      return rows.map(function (r) {
        return '<div class="rf-summary__row' + (r[2] ? ' is-missing' : '') + '"><span>' + esc(r[0]) + '</span><span>' + esc(r[1]) + '</span></div>';
      }).join('') +
        codeHtml() +
        '<div class="rf-summary__total"><span>' + esc(t.sumTotal) + '</span><strong>' + (discountOff() ? '<s>' + money(total()) + '</s> ' : '') + money(toPay()) + '</strong></div>' +
        '<label class="rf-check rf-summary__consent"><input type="checkbox" data-consent' + (state.consent ? ' checked' : '') + '><span>' + esc(t.consent) + '</span></label>' +
        (errors.length ? '<div class="rf-summary__errors" role="alert">' + errors.map(function (e) { return '<span>' + esc(e) + '</span>'; }).join('') + '</div>' : '') +
        '<button type="button" class="rf-btn rf-btn--primary rf-btn--block" data-checkout' + (busy ? ' disabled' : '') + '>' + ICON.lock + (busy ? esc(t.preparing) : esc(t.checkout)) + '</button>' +
        (t.guarantee ? '<p class="rf-summary__guarantee">' + ICON.shield + '<span>' + esc(t.guarantee) + '</span></p>' : '') +
        '<p class="rf-note rf-summary__secure">' + esc(t.secure) + '</p>' +
        '<div data-preview-out></div>';
    }

    // livrarea urgenta: un produs Shopify separat, adaugat in comanda cu o bifa
    function urgentHtml() {
      if (!cfg.urgent) return '';
      return '<label class="rf-urgent' + (state.urgent ? ' is-on' : '') + '">' +
        '<input type="checkbox" data-urgent' + (state.urgent ? ' checked' : '') + '>' +
        (cfg.urgent.image ? '<img class="rf-urgent__img" src="' + esc(cfg.urgent.image) + '" alt="" width="64" height="64" loading="lazy">' : '') +
        '<span class="rf-urgent__text"><strong>' + esc(t.urgentTitle) + '</strong><small>' + esc(t.urgentText) + '</small></span>' +
        '<span class="rf-urgent__price">+ ' + money(cfg.urgent.price) + '</span></label>';
    }

    function contactMsg() {
      if (state.delivery !== 'email') return phoneMsg();
      if (!state.email) return '<span class="rf-field__msg">' + esc(t.emailHelp) + '</span>';
      var e = validEmail(state.email);
      return e ? '<span class="rf-field__msg rf-field__msg--ok">' + esc(t.emailOk) + ' ' + esc(e) + '</span>'
        : (state.email.indexOf('@') > 0 && state.email.length > 7 ? '<span class="rf-field__msg rf-field__msg--error">' + esc(t.emailError) + '</span>'
          : '<span class="rf-field__msg">' + esc(t.emailHelp) + '</span>');
    }

    // pasul 4: unde trimitem fotografiile. Omul alege WhatsApp sau e-mail si completeaza doar campul ales.
    function contactHtml() {
      var tab = function (kind, label) {
        var on = state.delivery === kind;
        return '<button type="button" class="rf-choice' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-delivery="' + kind + '">' + esc(label) + '</button>';
      };
      var input = state.delivery === 'email'
        ? '<input class="rf-input" type="email" inputmode="email" autocomplete="email" placeholder="' + esc(t.emailPlaceholder) + '" aria-label="' + esc(t.deliveryEmail) + '" data-email value="' + esc(state.email) + '">'
        : '<input class="rf-input" type="tel" inputmode="tel" autocomplete="tel" placeholder="' + esc(t.phonePlaceholder) + '" aria-label="' + esc(t.deliveryWhatsapp) + '" data-phone value="' + esc(state.phone) + '">';
      var warn = state.delivery === 'email' ? t.checkEmail : t.checkPhone;
      return '<div class="rf-choices" role="radiogroup" aria-label="' + esc(t.stepPhone) + '">' + tab('whatsapp', t.deliveryWhatsapp) + tab('email', t.deliveryEmail) + '</div>' +
        '<div class="rf-field rf-phone">' + input + '<span data-phone-msg>' + contactMsg() + '</span></div>' +
        (warn ? '<p class="rf-contact__warn">' + ICON.warn + '<span>' + esc(warn) + '</span></p>' : '');
    }

    function phoneMsg() {
      if (!state.phone) return '<span class="rf-field__msg">' + esc(t.phoneHelp) + '</span>';
      var n = normalizePhone(state.phone);
      return n ? '<span class="rf-field__msg rf-field__msg--ok">' + esc(t.phoneOk) + ' ' + prettyPhone(n) + '</span>'
        : '<span class="rf-field__msg rf-field__msg--error">' + esc(t.phoneError) + '</span>';
    }

    function render() {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-rf-service-tab') === state.service;
        tab.classList.toggle('is-on', on);
        tab.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      panes.forEach(function (pane) { pane.hidden = pane.getAttribute('data-rf-pane') !== state.service; });
      packBtns.forEach(function (btn) {
        btn.setAttribute('aria-pressed', state.service === 'restore' && Number(btn.getAttribute('data-rf-pack')) === state.pack ? 'true' : 'false');
      });

      var open = state.service === 'restore' ? !!pack() : !!cfg.person;
      box.hidden = !open;
      if (!open) { box.innerHTML = ''; return; }

      var list = slots();
      var canAdd = state.service === 'person' && state.persons < cfg.maxPersons;
      box.innerHTML =
        '<div class="rf-step"><p class="rf-step__title"><span class="rf-step__num">3</span>' + esc(t.stepPhotos) + '</p>' +
        '<div class="rf-config__grid' + (list.length > 2 ? ' rf-config__grid--3' : '') + '">' + list.map(slotHtml).join('') + '</div>' +
        (canAdd ? '<button type="button" class="rf-add" data-add-person>' + ICON.plus + esc(t.addPerson) +
          (cfg.extra && state.persons >= cfg.person.included ? ' (+ ' + money(cfg.extra.price) + ')' : '') + '</button>' : '') +
        '</div>' +
        '<div class="rf-step"><p class="rf-step__title"><span class="rf-step__num">4</span>' + esc(t.stepPhone) + '</p>' +
        '<div data-contact>' + contactHtml() + '</div></div>' +
        '<div class="rf-step"><p class="rf-step__title"><span class="rf-step__num">5</span>' + esc(t.stepSummary) + '</p>' +
        '<div data-urgent-box>' + urgentHtml() + '</div>' +
        '<div class="rf-card rf-summary" data-summary>' + summaryHtml() + '</div></div>';
    }

    function refreshMedia(key) {
      var holder = box.querySelector('[data-media="' + key + '"]');
      if (holder) holder.innerHTML = fileHtml(key, holder.hasAttribute('data-mini'));
    }
    function refreshSummary() {
      var el = box.querySelector('[data-summary]');
      if (el) el.innerHTML = summaryHtml();
    }

    /* ---------------------------------------------------------- serviciul */
    function auth() { return { 'X-Project-Token': state.token || '' }; }

    function ensureProject() {
      if (state.projectId) return Promise.resolve();
      return RF.api('/api/projects', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ service: state.service, visitor: RF.uid(), demoId: state.demo ? state.demo.id : null })
      }).then(function (res) {
        state.projectId = res.id; state.token = res.token;
        // fotografia din demo e deja la noi: nu o mai cerem o dată
        // (la demo-ul de adăugare persoană sunt două: fotografia principală și cea cu persoana)
        (res.demoSlots || (res.demoSlot ? [res.demoSlot] : [])).forEach(function (slot) {
          if (!state.demo || state.files[slot]) return;
          state.files[slot] = { status: 'done', thumb: slot === 'p1-ref-1' ? (state.demo.personThumb || state.demo.thumb) : state.demo.thumb };
          refreshMedia(slot);
        });
        refreshSummary();
        save();
      });
    }

    function put(key, blob, onProgress) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('PUT', RF.cfg.api.replace(/\/+$/, '') + '/api/projects/' + state.projectId + '/files/' + key);
        xhr.setRequestHeader('Content-Type', 'image/jpeg');
        xhr.setRequestHeader('X-Project-Token', state.token);
        xhr.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100)); };
        xhr.onload = function () { xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(Object.assign(new Error('upload'), { status: xhr.status })); };
        xhr.onerror = function () { reject(new Error('network')); };
        xhr.send(blob);
      });
    }

    function upload(key, file, retried) {
      errors = [];
      var entry = { status: 'uploading', progress: 0, thumb: (state.files[key] || {}).thumb || '' };
      state.files[key] = entry;
      refreshMedia(key);

      RF.shrinkImage(file).then(function (img) {
        entry.thumb = RF.thumb(img.canvas, 420);
        refreshMedia(key);
        if (!RF.cfg.api) throw Object.assign(new Error('no-api'), { code: 'no-api' });
        return ensureProject().then(function () {
          return put(key, img.blob, function (pct) {
            entry.progress = pct;
            var bar = box.querySelector('[data-bar="' + key + '"]');
            if (bar) bar.style.width = pct + '%';
          });
        });
      }).then(function () {
        if (state.files[key] !== entry) return;             // între timp a fost ștearsă sau înlocuită
        entry.status = 'done'; delete entry.progress;
        RF.track('photo_upload', { service: state.service, slot: key });
        refreshMedia(key); refreshSummary(); save();
      }).catch(function (err) {
        if (state.files[key] !== entry) return;
        // proiectul a expirat pe server: pornim unul nou și mai încercăm o dată
        if (!retried && (err.status === 404 || err.status === 401)) {
          state.projectId = null; state.token = null;
          Object.keys(state.files).forEach(function (k) { if (k !== key) delete state.files[k]; });
          render();
          return upload(key, file, true);
        }
        entry.status = 'error';
        entry.error = err.message === 'decode' ? t.errDecode
          : err.code === 'no-api' ? t.errNoApi
          : err.status === 413 ? t.errTooLarge
          : t.errNetwork;
        refreshMedia(key); refreshSummary();
      });
    }

    function remove(key) {
      delete state.files[key];
      if (state.projectId) {
        RF.api('/api/projects/' + state.projectId + '/files/' + key, { method: 'DELETE', headers: auth() }).catch(function () {});
      }
      refreshMedia(key); refreshSummary(); save();
    }

    /* ---------------------------------------------------- spre coș și plată */
    function validate() {
      var out = [], pr = progress();
      if (pr.ok < pr.total) {
        out.push(state.service === 'restore'
          ? tx(pr.total - pr.ok === 1 ? 'needOne' : 'needMany', pr.total - pr.ok)
          : (!done('main') ? t.needMain : t.needRefs));
      }
      if (Object.keys(state.files).some(function (k) { return state.files[k].status === 'uploading'; })) out.push(t.needWait);
      if (state.delivery === 'email') { if (!validEmail(state.email)) out.push(t.needEmail); }
      else if (!normalizePhone(state.phone)) out.push(t.needPhone);
      if (!state.consent) out.push(t.needConsent);
      return out;
    }

    function payload() {
      var used = slots(), items = [];
      used.forEach(function (s) {
        var keys = s.kind === 'person' ? refKeys(s.n).filter(done) : [s.key];
        items.push({ slot: s.key, kind: s.kind, files: keys, note: (state.notes[s.key] || '').trim(),
                     color: s.kind === 'photo' ? state.color[s.key] !== false : undefined });
      });
      var props = {
        'Serviciu': state.service === 'restore' ? t.serviceRestore : t.servicePerson,
        'Cod proiect': state.projectId,
        'Livrare': state.delivery === 'email' ? t.deliveryEmailName : t.delivery
      };
      // numele acestor doua campuri sunt citite de serviciu de pe comanda: nu se traduc
      if (state.delivery === 'email') props['E-mail'] = validEmail(state.email);
      else props['WhatsApp'] = normalizePhone(state.phone);
      if (state.service === 'restore') props['Fotografii'] = String(pack().photos);
      else props['Persoane'] = String(state.persons);
      items.forEach(function (it) {
        if (!it.note) return;
        props['Indicații ' + (it.kind === 'photo' ? 'fotografia ' + it.slot.split('-')[1] : it.kind === 'main' ? 'fotografia principală' : 'persoana ' + it.slot.slice(1))] = it.note;
      });
      props['_project_id'] = state.projectId;

      var lines = [];
      if (state.service === 'restore') lines.push({ id: pack().variantId, quantity: 1, properties: props });
      else {
        lines.push({ id: cfg.person.variantId, quantity: 1, properties: props });
        if (extraPersons() > 0 && cfg.extra) {
          lines.push({ id: cfg.extra.variantId, quantity: extraPersons(), properties: { 'Cod proiect': state.projectId, '_project_id': state.projectId } });
        }
      }
      if (urgentOn()) lines.push({ id: cfg.urgent.variantId, quantity: 1, properties: { 'Cod proiect': state.projectId, '_project_id': state.projectId } });
      return {
        project: { service: state.service, delivery: state.delivery, phone: props['WhatsApp'] || null, email: props['E-mail'] || null, photos: state.service === 'restore' ? pack().photos : null,
                   persons: state.service === 'person' ? state.persons : null, items: items },
        lines: lines
      };
    }

    function post(url, body) {
      return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body || {}) })
        .then(function (res) { if (!res.ok) throw new Error('cart-' + res.status); return res.json(); });
    }

    function checkout() {
      if (busy) return;
      errors = validate();
      if (errors.length) { refreshSummary(); return; }
      busy = true; refreshSummary();
      var data = payload();
      // un cod respins nu se mai trimite; unul neverificat merge mai departe si il judeca Shopify la plata
      var code = state.hasCode && !(discount && discount.status === 'bad') ? cleanCode(state.code) : '';
      discountRun += 1;                                       // o verificare in curs nu mai are voie sa umble la cos
      RF.track('configuration_complete', { service: state.service, value: toPay() / 100, project: state.projectId });

      RF.api('/api/projects/' + state.projectId, {
        method: 'PUT', headers: Object.assign({ 'Content-Type': 'application/json' }, auth()), body: JSON.stringify(data.project)
      }).then(function () {
        if (RF.cfg.preview) {                                // previzualizare locală: nu există coș Shopify
          busy = false; refreshSummary();
          box.querySelector('[data-preview-out]').innerHTML = '<div class="rf-summary__preview">PREVIZUALIZARE — pe Shopify, de aici se deschide checkout-ul.\nÎn coș ar intra:\n' + esc(JSON.stringify(data.lines, null, 2)) + '</div>';
          return;
        }
        // coșul se golește întâi, ca o configurare mai veche să nu fie plătită a doua oară
        return post(cfg.cartClearUrl)
          .then(function () { return post(cfg.cartAddUrl, { items: data.lines }); })
          .then(function () { return post(cfg.cartUpdateUrl, Object.assign({ attributes: { 'Cod proiect': state.projectId } }, code ? { discount: code } : {})); })
          .then(function () {
            RF.track('add_to_cart', { value: toPay() / 100, currency: 'RON', service: state.service });
            RF.track('checkout_start', { value: toPay() / 100, currency: 'RON', service: state.service });
            window.location.assign(cfg.checkoutUrl + (code ? (cfg.checkoutUrl.indexOf('?') < 0 ? '?' : '&') + 'discount=' + encodeURIComponent(code) : ''));
          });
      }).catch(function () {
        busy = false;
        errors = [t.errCheckout];
        refreshSummary();
      });
    }

    /* ---------------------------------------------------------- evenimente */
    function setService(service, scroll) {
      if (service === 'person' && !cfg.person) return;
      if (state.service !== service) {
        // alt serviciu = alt proiect; fotografiile deja urcate rămân la proiectul vechi și expiră singure
        state.service = service; state.projectId = null; state.token = null; state.files = {}; errors = [];
        RF.track('service_select', { service: service });
        render(); save(); recheckCode();
      }
      if (scroll && !box.hidden) RF.scrollTo(box);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { setService(tab.getAttribute('data-rf-service-tab'), tab.getAttribute('data-rf-service-tab') === 'person'); });
    });
    packBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.pack = Number(btn.getAttribute('data-rf-pack'));
        errors = [];
        var p = pack();
        RF.track('package_select', { photos: p.photos, value: p.price / 100, currency: 'RON' });
        render(); save(); recheckCode();
        RF.scrollTo(box);
      });
    });
    document.addEventListener('rf:service', function (e) { setService(e.detail.service, false); });
    document.addEventListener('rf:demo-buy', function (e) {
      var person = e.detail.kind === 'person' && !!cfg.person;
      state.demo = e.detail;                                 // { id, kind, thumb, personThumb, color }
      if (!person && e.detail.color === false) state.color['photo-1'] = false;   // demo-ul a fost cerut alb-negru
      // omul ajunge la pachetul felului de demo pe care l-a făcut
      if (state.service !== (person ? 'person' : 'restore')) setService(person ? 'person' : 'restore', false);
      if (state.projectId && !state.files[person ? 'main' : 'photo-1']) { state.projectId = null; state.token = null; }
      save();
      // la adăugare persoană cele două fotografii apar pe loc în casetele lor
      if (person) ensureProject().catch(function () { /* le poate încărca și de mână */ });
    });

    box.addEventListener('change', function (e) {
      var el = e.target;
      if (el.matches('[data-file]')) {
        if (el.files && el.files[0]) upload(el.getAttribute('data-file'), el.files[0]);
        el.value = '';
      } else if (el.matches('[data-color]')) {
        state.color[el.getAttribute('data-color')] = el.checked; save();
      } else if (el.matches('[data-urgent]')) {
        state.urgent = el.checked; save();
        box.querySelector('[data-urgent-box]').innerHTML = urgentHtml();
        refreshSummary(); recheckCode();
        RF.track('urgent_select', { on: state.urgent });
      } else if (el.matches('[data-has-code]')) {
        state.hasCode = el.checked; if (!el.checked) { discount = null; discountRun += 1; } save(); refreshSummary();
        if (el.checked) { var field = box.querySelector('[data-code]'); if (field) field.focus(); }
      } else if (el.matches('[data-consent]')) {
        state.consent = el.checked; errors = []; save(); refreshSummary();
      } else if (el.matches('[data-phone], [data-email]')) {
        refreshSummary();
      }
    });
    box.addEventListener('input', function (e) {
      var el = e.target;
      if (el.matches('[data-note]')) { state.notes[el.getAttribute('data-note')] = el.value; save(); }
      else if (el.matches('[data-code]')) {
        state.code = el.value; save();
        if (discount && cleanCode(el.value) !== discount.code) {        // alt cod decat cel verificat: reducerea veche nu mai e valabila
          discount = null; discountRun += 1; refreshSummary();
          var again = box.querySelector('[data-code]');
          if (again) { again.focus(); again.setSelectionRange(again.value.length, again.value.length); }
        }
      }
      else if (el.matches('[data-phone]')) {
        state.phone = el.value; save();
        var ok = normalizePhone(el.value);
        el.classList.toggle('is-ok', !!ok);
        el.classList.toggle('is-error', !ok && el.value.replace(/\D/g, '').length >= 10);
        box.querySelector('[data-phone-msg]').innerHTML = phoneMsg();
      }
      else if (el.matches('[data-email]')) {
        state.email = el.value; save();
        el.classList.toggle('is-ok', !!validEmail(el.value));
        box.querySelector('[data-phone-msg]').innerHTML = contactMsg();
      }
    });
    box.addEventListener('click', function (e) {
      var el = e.target.closest('[data-remove],[data-add-person],[data-remove-person],[data-checkout],[data-delivery],[data-code-apply]');
      if (!el) return;
      if (el.hasAttribute('data-code-apply')) { state.code = cleanCode((box.querySelector('[data-code]') || {}).value); save(); applyCode(); return; }
      if (el.hasAttribute('data-delivery')) {
        state.delivery = el.getAttribute('data-delivery'); errors = []; save();
        box.querySelector('[data-contact]').innerHTML = contactHtml();
        refreshSummary();
        RF.track('delivery_select', { delivery: state.delivery });
        return;
      }
      if (el.hasAttribute('data-remove')) remove(el.getAttribute('data-remove'));
      else if (el.hasAttribute('data-add-person')) { state.persons = Math.min(cfg.maxPersons, state.persons + 1); render(); save(); recheckCode(); }
      else if (el.hasAttribute('data-remove-person')) {
        refKeys(state.persons).forEach(function (k) { if (state.files[k]) remove(k); });
        delete state.notes['p' + state.persons];
        state.persons = Math.max(1, state.persons - 1); render(); save(); recheckCode();
      }
      else if (el.hasAttribute('data-checkout')) checkout();
    });
    // pe desktop: fotografia poate fi trasă direct peste casetă
    box.addEventListener('dragover', function (e) {
      var drop = e.target.closest('[data-drop]');
      if (drop) { e.preventDefault(); drop.classList.add('is-over'); }
    });
    box.addEventListener('dragleave', function (e) {
      var drop = e.target.closest('[data-drop]');
      if (drop) drop.classList.remove('is-over');
    });
    box.addEventListener('drop', function (e) {
      var drop = e.target.closest('[data-drop]');
      if (!drop) return;
      e.preventDefault(); drop.classList.remove('is-over');
      var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (file) upload(drop.getAttribute('data-drop'), file);
    });

    render();

    // venit de pe /cart (care trimite aici): mergem la comanda începută sau, dacă nu există, la pachete
    if (window.location.hash === '#configurator') {
      // fără animație: omul tocmai a fost redirecționat și trebuie să ajungă direct la locul lui
      setTimeout(function () { (box.hidden ? sec : box).scrollIntoView({ behavior: 'instant', block: 'start' }); }, 350);
    }
  }

  RF.order ={ normalizePhone: normalizePhone };
  RF.register(function (root) { root.querySelectorAll('[data-rf-order]').forEach(init); });
})();
